import type { PrimitiveAtom } from 'jotai';
import { atom } from 'jotai';

export const giveawayCheckResultsUrlAtom = atom(null) as PrimitiveAtom<string>;
export const giveawayDrawIdAtom = atom(null) as PrimitiveAtom<string>;
export const giveawayResultSignatureAtom = atom(null) as PrimitiveAtom<string>;
